<template>
  <div class="container fixedElement">
    <div class="row">
      <div class="col-lg-9 col-md-12 col-sm-12 col-xs-12">
        <div class="row">
          <div class="b-left col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="head row" :class="{ 'head-border': selectedType == 1 }">
              <div id="title" class="col">
                <i class="icon-flight filter-icon"></i>
                <span> پرواز رفت</span>
              </div>
            </div>
            <br />

            <div class="flight container">
              <div v-if="selectedDeparture != null" id="departure" class="row">
                <div style="display: contents">
                  <i class="icon mleft-5 icon-reply-1"></i>
                  <div class="mleft-5 segment">
                    <span>{{ selectedDeparture.originCity }}</span>
                    <span>{{ selectedDeparture.departureTime }}</span>
                  </div>
                  <div class="flight-segment">
                    <div id="duration"></div>
                    <div class="stop-diagram"></div>
                    <div id="textDate">
                      {{ selectedDeparture.departureDateTimeShamsiText }}
                    </div>
                  </div>

                  <div class="mleft-5 segment">
                    <span>{{ selectedDeparture.destinationCity }}</span>
                    <span>{{ selectedDeparture.arrivalTime }}</span>
                  </div>
                </div>
                <div style="display: contents">
                  <div id="action-icon">
                    <i class="action icon-eye-1"></i>
                    <img
                      id="airline-logo"
                      width="28"
                      height="28"
                      src="../../../public/img/airlines/zv.png"
                    />
                  </div>
                  <a @click="onChange(1)" class="change-hf">
                    <span>تغییر</span>
                  </a>
                </div>
                <div class="adult-price">
                  <span>قیمت پرواز رفت: </span>
                  <span style="color: #08446a"
                    >{{
                      selectedDeparture.totalAdultFare | numFormat
                    }}
                    ريال</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="b-left col-lg-6 col-md-6 col-sm-12 col-xs-12">
            <div class="head row" :class="{ 'head-border': selectedType == 2 }">
              <div id="title" class="col">
                <i class="icon-flight filter-icon"></i>
                <span> پرواز برگشت</span>
              </div>
            </div>
            <br />
            <div class="flight container">
              <div v-if="selectedReturn != null" id="departure" class="row">
                <div style="display: contents">
                  <i class="icon mleft-5 icon-forward-1"></i>
                  <div class="mleft-5 segment">
                    <span>{{ selectedReturn.originCity }}</span>
                    <span>{{ selectedReturn.departureTime }}</span>
                  </div>
                  <div class="flight-segment">
                    <div id="duration"></div>
                    <div class="stop-diagram"></div>
                    <div id="textDate">
                      {{ selectedReturn.departureDateTimeShamsiText }}
                    </div>
                  </div>

                  <div class="mleft-5 segment">
                    <span>{{ selectedReturn.destinationCity }}</span>
                    <span>{{ selectedReturn.arrivalTime }}</span>
                  </div>
                </div>
                <div style="display: contents">
                  <div id="action-icon">
                    <i class="action icon-eye-1 filter-icon"></i>
                    <img
                      id="airline-logo"
                      width="28"
                      height="28"
                      src="../../../public/img/airlines/zv.png"
                    />
                  </div>
                  <a @click="onChange(2)" class="change-hf">
                    <span>تغییر</span>
                  </a>
                </div>
                <div class="adult-price">
                  <span>قیمت پرواز برگشت: </span>
                  <span style="color: #08446a"
                    >{{ selectedReturn.totalAdultFare | numFormat }} ريال</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-12 col-sm-12 col-xs-12">
        <div class="total-pay">
          <div class="row">
            <span id="title">پرواز رفت + برگشت </span>
          </div>

          <div class="liner"></div>
          <div style="text-align: center" class="row">
            <span
              ><span style="font-size: 16px">کل هزینه سفر :</span>

              <label style="font-size: 14px; font-weight: bold; color: #08446a"
                >{{ calcTotlaPrice | numFormat }} ريال</label
              ></span
            >
          </div>
          <div class="row">
            <button
              v-if="selectedDeparture === null || selectedReturn === null"
              style="background-color: #c4dcf7"
              class="btn btn-block"
              data-toggle="modal"
              data-target="#myReview"
            >
              تکمیل رزرو
            </button>
          </div>

          <div class="row">
            <button
              v-if="selectedDeparture != null && selectedReturn != null"
              class="btn btn-block btn-primary"
              data-toggle="modal"
              data-target="#myReview"
              @click="book"
            >
              تکمیل رزرو
            </button>
          </div>
        </div>
        <!-- <SKLTotalPrice class="total-pay" /> -->
      </div>
    </div>

    <div class="subtitle row">
      <div class="col">
        به هنگام رزرو پرواز و هتل در آن واحد، تا 15% صرفه جویی کنید!
      </div>
    </div>
  </div>
</template>
<script>
import SKLTotalPrice from "@/components/shared/Skeletons/SKLTotalPrice";

export default {
  name: "SelectedPackage",

  components: { SKLTotalPrice },
  props: {
    showPrice: Boolean,
    selectedDeparture: Object,
    selectedReturn: Object,

    selectedType: { type: Number, default: 1 },
    sleketonModel: {
      type: Object,
      default: () => ({
        isDeparture: false,
        isReturn: false,
        isToway: false,
        isRoom: false,
        isTotalPrice: false,
      }),
    },
    isDisableButton: Boolean,
  },
  data: () => ({
    params: {},
  }),
  computed: {
    flightHeaderClass: function () {
      return {
        "head-border": this.selectedType === 1 || this.selectedType === 2,
      };
    },
    calcTotlaPrice() {
      if (this.selectedReturn != null && this.selectedDeparture != null)
        return (
          parseInt(this.selectedDeparture.totalAdultFare) +
          parseInt(this.selectedReturn.totalAdultFare)
        );
      else if (this.selectedDeparture != null) {
        return this.selectedDeparture.totalAdultFare;
      } else return 0;
    },
  },
  methods: {
    onChange(stpe) {
      this.$emit("onChange", stpe);
    },
    book() {
      const data = {
        selectedDeparture: this.selectedDeparture,
        selectedReturn: this.selectedReturn,
      };

      this.$store.dispatch("storeTwoWaySelectedFlight", data);

      this.params = this.$route.query;

      this.$router.push({
        path: "flightbook",
        name: "flightbook",
        query: {
          originName: this.params.originName,
          destinationName: this.params.destinationName,
          origin: this.params.origin,
          destination: this.params.destination,
          fromDate: this.params.fromDate,
          toDate: this.params.toDate,
          adultQty: this.params.adultQty,
          infantQty: this.params.infantQty,
          childQty: this.params.childQty,
          tripType: this.params.tripType,
        },
      });
    },
  },
  created() {
    this.params = this.$route.query;
  },
  watch: {
    selectedDeparture(val) {
      this.departureDateList = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.liner {
  border: 1px solid #eeeeee;
  margin-bottom: 8px;
  margin-top: 5px;
}
.change-hf {
    position: absolute;
    border-radius: 20px;
    background-color: #00c3e1;
    padding: 6px 20px;
    display: inline-table;
    color: #fff !important;
    font-weight: 100;
    left: 16px;
}
.change-hf:hover {
  position: absolute;
  border-radius: 5px;
  padding: 3px 7px 3px 7px;
  display: inline-table;
  color: #fdfeff !important;
  background: #02b1cc;
  font-weight: 100;
  left: 16px;
  cursor: pointer;
}
.flight-segment {
  text-align: center;
  color: #08446a;
  font-size: 12px;
}
#airline-logo {
  margin-top: -6px !important;
}
.title span #price {
  font-weight: bold;
}
.total-pay {
  padding: 20px 40px 14px 40px;
}
.total-pay a {
  margin-top: 14px;
}

.total-pay span {
  margin-bottom: 35px;
  margin-top: 15px;
}
.total-pay #title {
  margin: auto;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}
#hotel-detail {
  line-height: 24px;
  font-size: 13px;
  padding: 0px 2px 0px 0px;
}

#hotel-title {
  font-weight: bold;
  font-size: 13px;
  margin-bottom: 11px;
  // margin-top: 14px;
}
.hotel #hotel-image {
  border-radius: 8px;
  margin-left: 5px;
}
.stop-diagram {
  height: 1px;
  background: #c7c1c1;
  width: 100px;
  margin-top: auto;
  margin-bottom: auto;

  margin-left: 8px;
  margin-right: 8px;
}

.mleft-5 {
  margin-left: 5px;
}
.head {
  margin: 0px -3px 0px -8px;
  padding-top: 6px;
  border-radius: 5px;
}
.head-border {
  border-top: 2px #fcbe2f solid;
}
.head #title {
  font-size: 15px;
  color: #5c666b;
}
.head #change {
  text-align: left;
  color: #0a6c9f;
  cursor: pointer;
  font-size: 15px;
  margin-left: 5px;
}
.fixedElement {
  background-color: rgb(255, 255, 255);
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 100;
  padding: 5px 10px 5px 10px;
  border-radius: 5px;
  margin-bottom: 20px;
  box-shadow: 3px 3px 3px 3px #aaaaaa4a;
}
.flight {
  padding: 0px 0px 0px 0px;
}
.flight #departure {
  margin: 10px 0 10px 0;
}
.flight #departure .icon {
  margin-top: auto;
  margin-bottom: auto;
  font-size: 15px;
  color: #867b7b;
}
.flight #departure #action-icon {
  margin-top: auto;
  margin-bottom: auto;
  font-size: 18px;
  color: #8da6b3;
  margin-right: 15px;
}
.action:hover {
  cursor: pointer;
  // font-size: 20px;
}
.segment {
  text-align: center;
  display: grid;
}
.b-left {
  border-left: 1px #e2e2e2 solid;
}
.subtitle {
  border-top: 1px #c5c5c5 solid;
  margin-left: 20px;
  margin-right: 20px;
  padding: 10px 1px 10px 1px;
}

.subtitle-display {
  display: none;
}
.subtitle div {
  text-align: left;
  color: #265215;
  font-size: 15px;
}
.adult-price {
  font-size: 14px;
  text-align: center !important;
  margin-top: 25px;
  margin-right: 8%;
  margin-bottom: 25px;
}
</style>